<template>
  <div class="commodityDetails">
    <div class="top_banner">
      <img class="top_logo" src="../../assets/tfsharelogo.png" alt="">
      <div class="middel-info">
        <div>铁粉生活</div>
        <div class="s_text">湖南广电旗下唯一本地生活服务APP</div>
      </div>
      <div id="btn_open">打开APP</div>
    </div>
    <div style="margin-top: 55px;" v-if="!isEmpty">
      <div class="banner" :style="{height: bannerHeight + 'px'}" @touchstart="handleTouchStart" @touchend="handleTouchEnd" v-if="info.playImagesUrl && info.playImagesUrl.length > 0">
        <Carousel :autoplay-speed="5000" autoplay loop v-model="mIndex">
          <Carousel-item v-for="(item, index) in info.playImagesUrl" :key="index">
            <div class="demo-carousel">
              <img :src="item" alt="" ref="bannerImgs" />
            </div>
          </Carousel-item>
        </Carousel>
      </div>
      <div class="detailInfo">
        <div class="infoTitle">
          {{ info.name }}
          <span class="tip" v-if="info.salePlatform == 2">（仅安卓平台销售）</span>
          <span class="tip" v-else-if="info.salePlatform == 3">（仅安卓平台销售）</span>
        </div>
        <div class="infoContent">
          <div>
            <span style="font-size: 13px">补贴价</span><span class="info_price"><span style="font-size: 12px">￥</span>{{ info.price | priceFormat }}</span>
          </div>
          <div class="salesQuantity">
            已售：{{ info.saleNum }}
          </div>
        </div>
      </div>
      <div class="goodsDetail">
        <div class="goodsDetail_title">产品详情</div>
        <div class="goodsDetail_content" v-html="info.describ">
        </div>
      </div>
    </div>
    <div v-else class="empty_container" :style="{'height': contentHeight + 'px'}">商品已被删除</div>
    <Spin fix size="large" v-if="loading"></Spin>
  </div>
</template>
<script>
export default {
  name: "goodsPage",
  components: {},
  data() {
    return {
      loading: true,
      isEmpty: false,
      bannerHeight: 200,
      mIndex: 0,
      mx0: 0,
      mx1: 0,
      info: {
        name: '',
        price: 0,
        saleNum: '',
        describ: '',
        playImagesUrl: []
      },
      contentHeight: document.documentElement.clientHeight,
    };
  },
  filters: {
    priceFormat: function (value) {
      if (!value) return '0'
      return (value / 100).toFixed(2)
    }
  },
  mounted() {
    let param = this.$route.query
    this.getGoodsInfo(param)

    // linkType(4:商品)
    var data = XInstall.parseUrlParams();
    new XInstall({
      appKey : "mq81ipn",
      buttonId: [
        { idName: 'btn_open', params: {linkType: 4, linkId: param.id} }
      ]
    }, data);
  },
  methods: {
    getGoodsInfo(param) {
      let that = this
      that.loading = true
      this.$http.get('/goods/open/detailForShare', {
        'id': param.id
      }, function (data) {
        that.info = data.data
        that.isEmpty = false
        that.loading = false

        that.$nextTick(function () {
          setTimeout(function() {
            that.bannerHeight = that.$refs['bannerImgs'][0].offsetHeight
          }, 200)
        })
      }, function () {
        that.isEmpty = true
        that.loading = false
      })
    },
    handleTouchStart(e) {
      this.mx0 = e.changedTouches[0].pageX
    },
    handleTouchEnd(e) {
      this.mx1 = e.changedTouches[0].pageX;
      let tag = this.mx1 - this.mx0;
      if(tag >= 50){
        if(this.mIndex > 0){
          this.mIndex--;
        }else{
          this.mIndex = this.info.playImagesUrl.length - 1;
        }
      }
      if(tag <= -50){
        if(this.mIndex < this.info.playImagesUrl.length - 1){
          this.mIndex++;
        }else{
          this.mIndex = 0;
        }
      }
    }
  },
};
</script>
<style scoped>
.commodityDetails {
  background: #eee;
  position: relative;
}
.top_banner {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 99;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  font-weight: 500;
  background: rgb(255, 255, 255);
  padding: 6px;
  color: #000;
  border-bottom: 1px solid #eee;
}
.top_logo {
  width: 40px;
  border-radius: 6px;
}
.middel-info {
  flex: 1;
  margin-left: 6px;
  font-size: 16px;
}
.s_text {
  font-size: 12px;
  color: rgba(153,153,153,1);
}
#btn_open {
  background-color: #3C74F2;
  padding: 5px 10px;
  font-size: 12px;
  border-radius: 20px;
  color: #fff;
}
.top {
  width:100%;
  position: fixed;
  top:0;
  z-index: 99;
  display: flex;
  height: 50px;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  font-weight: 500;
  background: white;
}
.details_icon{
    position: absolute;
    left:10px;
    font-size: 22px;
}
.banner {
  overflow: hidden;
  background-color: #fff;
}
.banner >>> .ivu-carousel {
  height: 100%;
}
.demo-carousel {
  text-align: center;
}
.banner img {
  width: 100%;
}
.detailInfo {
  background: white;
  margin-top: 10px;
  padding: 10px;
}
.infoTitle {
  font-size: 16px;
  font-weight: bold;
}
.tip {
  font-size: 12px;
  font-weight: normal;
}
.infoContent {
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
  align-items: center;
}
.info_price {
  font-size: 20px;
  font-weight: bold;
  display: inline-block;
  color: #EF7409;
}
.salesQuantity {
  font-size: 13px;
  color: #EF7409;
  background-color: #eee;
  padding: 0 10px;
  border-radius: 9px;
}
.goodsDetail {
  background: white;
  margin-top: 10px;
}
.goodsDetail_title {
  font-size: 16px;
  font-weight: bold;
  padding: 10px;
}
.goodsDetail_content{
  width: 100%;
  padding: 10px;
}
.goodsDetail_content >>> img{
  width:100%;
}
.empty_container {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  background-color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/goods.vue